import { createUseStyles } from 'react-jss'

import { gap } from '../styles'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 8,
    marginTop: gap
  },
  panel: {
    padding: 30,
    flex: 1,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8,
    minHeight: 350,
    marginTop: [0, '!important']
  },
  leftSide: {
    flex: 1
  },
  rightSide: {
    flex: 1
  },
  valueTitle: {
    fontSize: 17,
    marginBottom: 18,
    display: 'flex',
    alignItems: 'center',
    gap: 5
  },
  value: {
    fontSize: 40
  },
  subValue: {
    fontSize: 24,
    fontWeight: 700
  }
})

export default useStyles
